import logo_mapid from "../Assets/svg/logo_mapid_no_outline.svg";
import logo_mapid_black from "../Assets/svg/logo_mapid_black.svg";
import logo_cilicis from "../Assets/svg/logo_outline_cilicis.svg";
import logo_brantas from "../Assets/svg/logo_outline_brantas.svg";
import logo_kemenperin from "../Assets/svg/logo_outline_kemenperin.svg";
import logo_mrt from "../Assets/png_jpg/logo_outline_mrt.png";
import logo_hud from "../Assets/png_jpg/logo_hud.png";
import logo_danamas from "../Assets/png_jpg/logo_danamas.png";
import logo_befa from "../Assets/png_jpg/logo_befa.png";
import logo_kai from "../Assets/png_jpg/logo_kai.png";
import logo_atr from "../Assets/png_jpg/logo_atr.png";
import logo_mapid_triangle from "../Assets/svg/logo_mapid_triangle.svg";
import background_mapid from "../Assets/png_jpg/background_mapid.png";
import background_kai from "../Assets/png_jpg/background_kai.png";
import background_cilicis from "../Assets/png_jpg/background_cilicis.png";
import connected_future from "../Assets/svg/connected_future.svg";
import bapperidamadiun from "../Assets/png_jpg/bapperidamadiun.png";
import bapperidamadiunmobile from "../Assets/png_jpg/bapperidamadiunmobile.png";
import dsda from "../Assets/svg/dsda.svg";
import dsda_mobile from "../Assets/svg/dsdamobile.svg";
import logo_cbn from "../Assets/svg/logo_cbn.svg";
import logo_pelindo from "../Assets/png_jpg/logo_pelindo.png";

const domain_list = {
  // "d3msh8h9-3000.asse.devtunnels.ms": {
  //   mobile_logo: logo_mapid_triangle,
  //   logo: logo_mapid,
  //   logo_black: logo_mapid_black,
  //   title: "GEO",
  //   short_title: "GEO",
  //   sub_title: "PT. Multi Areal Planing Indonesia",
  //   background: background_mapid,
  //   form_link: "https://form.mapid.io/",
  //   status: "basic",
  //   is_domain_kai: true,
  //   show_survey_1: true,
  //   tag_line_image: connected_future,
  //   is_login_kai: false,
  // },
  "localhost:3000": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO",
    short_title: "GEO",
    sub_title: "PT. Multi Areal Planing Indonesia",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: true,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
  "localhost:3001": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "localhost:3002": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO",
    short_title: "GEO",
    sub_title: "PT. Multi Areal Planing Indonesia",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: false,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
  "geo.mapid.io": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO",
    short_title: "GEO",
    sub_title: "PT. Multi Areal Planing Indonesia",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: false,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "prod",
  },
  "geo-alpha.mapid.io": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO ALPHA",
    short_title: "GEO",
    sub_title: "Hanya untuk alpha tester",
    background: background_mapid,
    form_link: "https://form-alpha.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: false,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
  "geo-beta.mapid.io": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO",
    short_title: "GEO",
    sub_title: "Multi Areal Planing Indonesia",
    background: background_mapid,
    form_link: "https://form-beta.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: false,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
  // forward port (development only)
  "h7jbqbdj-3000.asse.devtunnels.ms": {
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "GEO",
    short_title: "GEO",
    sub_title: "PT. Multi Areal Planing Indonesia",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: true,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
  "kai.mapid.io": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "prod",
  },
  "kai-alpha.mapid.io": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "kai-beta.mapid.io": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "ptpi.mapid.io": {
    mobile_logo: logo_mapid,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "PTPI",
    short_title: "PTPI",
    sub_title: "PTPI LOCATION PLATFORM",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "danamas.mapid.io": {
    mobile_logo: logo_danamas,
    logo: logo_danamas,
    logo_black: logo_danamas,
    title: "DANAMAS",
    short_title: "DANAMAS",
    sub_title: "Danamas Location Intelligent Platform",
    background: background_mapid,
    form_link: "https://danamas-survey.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "befa.mapid.io": {
    mobile_logo: logo_befa,
    logo: logo_befa,
    logo_black: logo_befa,
    title: "BEFA",
    short_title: "BEFA",
    sub_title: "BEFA PLATFORM",
    background: background_mapid,
    form_link: "https://form-befa.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "befa-alpha.mapid.io": {
    mobile_logo: logo_befa,
    logo: logo_befa,
    logo_black: logo_befa,
    title: "BEFA",
    short_title: "BEFA",
    sub_title: "BEFA PLATFORM",
    background: background_mapid,
    form_link: "https://form-befa.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "alpha",
  },
  "hud.mapid.io": {
    mobile_logo: logo_hud,
    logo: logo_hud,
    logo_black: logo_hud,
    title: "HUD",
    short_title: "HUD",
    sub_title: "GIS PLATFORM ONLINE",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "mrt.mapid.io": {
    mobile_logo: logo_mrt,
    logo: logo_mrt,
    logo_black: logo_mrt,
    title: "MRT Jakarta",
    short_title: "MRTJ",
    sub_title: "Transit Oriented Development",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "ditjenikma.mapid.io": {
    mobile_logo: logo_kemenperin,
    logo: logo_kemenperin,
    logo_black: logo_kemenperin,
    title: "Kementerian Perindustrian",
    short_title: "Ditjenikma",
    sub_title: "DITJEN IKM Smart Data Center",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "ditjenikma-kemenperin.mapid.io": {
    mobile_logo: logo_kemenperin,
    logo: logo_kemenperin,
    logo_black: logo_kemenperin,
    title: "Kementerian Perindustrian",
    short_title: "Ditjenikma",
    sub_title: "DITJEN IKM Smart Data Center",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "desaku.mapid.io": {
    mobile_logo: logo_mapid,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "BATAS DESA",
    short_title: "DESAKU",
    sub_title: "BATAS DESA",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "bwsmalukuutara.mapid.io": {
    mobile_logo: logo_brantas,
    logo: logo_brantas,
    logo_black: logo_brantas,
    title: "BWS MALUKU UTARA",
    short_title: "BWS MALUKU UTARA",
    sub_title: "BWS MALUKU UTARA",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "bbwsbrantas.mapid.io": {
    mobile_logo: logo_brantas,
    logo: logo_brantas,
    logo_black: logo_brantas,
    title: "Smart Water Center",
    short_title: "SWC Brantas",
    sub_title: "BBWS Brantas",
    background: background_mapid,
    form_link: "https://brantas.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS BRANTAS",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "kabalai.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    background: background_mapid,
    sub_title: "BBWS Ciliwung Cisadane",
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "bbwsciliwungcisadane.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    sub_title: "BBWS Ciliwung Cisadane",
    background: background_cilicis,
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS CILIWUNG CISADANE",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "cilicis-alpha.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    sub_title: "BBWS Ciliwung Cisadane",
    background: background_cilicis,
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS CILIWUNG CISADANE",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
    env: "alpha",
  },
  "cilicis-beta.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    sub_title: "BBWS Ciliwung Cisadane",
    background: background_cilicis,
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS CILIWUNG CISADANE",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
    env: "alpha",
  },
  "sppr.mapid.io": {
    mobile_logo: logo_atr,
    logo: logo_atr,
    logo_black: logo_atr,
    title: "KEMENTERIAN AGRARIA DAN TATA RUANG BADAN PERTANAHAN NASIONAL",
    short_title: "SPPR | ATR BPN",
    sub_title: "ATR BPN",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "basic",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "bmnsunateraiv.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "BWS Padang",
    short_title: "BWS Padang",
    sub_title: "BWS Padang",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "bwssumatera5padang.mapid.io": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "BWS Padang",
    short_title: "BWS Padang",
    sub_title: "BWS Padang",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "bapperidamadiun.mapid.io": {
    mobile_logo: bapperidamadiunmobile,
    logo: bapperidamadiun,
    logo_black: bapperidamadiun,
    title: "BAPPERIDA MADIUN",
    short_title: "BAPPERIDA MADIUN",
    sub_title: "BAPPERIDA MADIUN",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    env: "prod",
  },
  "dsdajakarta.mapid.io": {
    mobile_logo: dsda_mobile,
    logo: dsda,
    logo_black: dsda,
    title: "DINAS SUMBER DAYA AIR JAKARTA",
    short_title: "DSDA JAKARTA",
    sub_title: "DSDA JAKARTA",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "prod",
  },
  "dsdajakarta-alpha.mapid.io": {
    mobile_logo: dsda_mobile,
    logo: dsda,
    logo_black: dsda,
    title: "DINAS SUMBER DAYA AIR JAKARTA",
    short_title: "DSDA JAKARTA",
    sub_title: "DSDA JAKARTA",
    background: background_mapid,
    form_link: "https://form-alpha.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "alpha",
  },
  "dsdajakarta-beta.mapid.io": {
    mobile_logo: dsda_mobile,
    logo: dsda,
    logo_black: dsda,
    title: "DINAS SUMBER DAYA AIR JAKARTA",
    short_title: "DSDA JAKARTA",
    sub_title: "DSDA JAKARTA",
    background: background_mapid,
    form_link: "https://form-beta.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "alpha",
  },
  "localhost:3003": {
    mobile_logo: dsda_mobile,
    logo: dsda,
    logo_black: dsda,
    title: "DINAS SUMBER DAYA AIR JAKARTA",
    short_title: "DSDA JAKARTA",
    sub_title: "DSDA JAKARTA",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    is_login_kai: false,
    is_hide_insight: true,
    env: "alpha",
  },
  "kim.kai.id": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form-kim.kai.id/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "prod",
  },
  "kim-alpha.kai.id": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form-alpha-kim.kai.id/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "kim-beta.kai.id": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form-beta-kim.kai.id/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "kim-alpha.mapid.io": {
    mobile_logo: logo_kai,
    logo: logo_kai,
    logo_black: logo_kai,
    title: "KAI Intelligence Map",
    short_title: "KIM",
    sub_title: "Powered by MAPID",
    background: background_kai,
    form_link: "https://form-beta-kim.kai.id/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Kereta Api Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: true,
    env: "alpha",
  },
  "cbn.mapid.io": {
    mobile_logo: logo_cbn,
    logo: logo_cbn,
    logo_black: logo_cbn,
    title: "PT. Cyberindo Aditama",
    short_title: "CBN",
    sub_title: "Powered by MAPID",
    background: background_mapid,
    form_link: "form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "PT. Cyberindo Aditama",
    continent: "Asia",
    industry: "",
    objective: "",
    is_login_kai: false,
    env: "prod",
  },
  "asset.mapid.io": {
    // module
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "Assets Development Intelligent Platform",
    short_title: "Assets Platform",
    sub_title: "Powered by MAPID",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    organization: "PT. Multi Areal Planing Indonesia",
    continent: "Asia",
    industry: "Transportation and Mobility",
    objective: "Develop Spatial Applications",
    is_login_kai: false,
    env: "prod",
  },
  "flood.mapid.io": {
    // module
    mobile_logo: logo_mapid_triangle,
    logo: logo_mapid,
    logo_black: logo_mapid_black,
    title: "Flood Platform",
    short_title: "Flood Platform",
    sub_title: "Powered by MAPID",
    background: background_cilicis,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "PT Multi Areal Planing Indonesia",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    env: "prod",
  },
  "10.30.114.111": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    sub_title: "BBWS Ciliwung Cisadane",
    background: background_cilicis,
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS CILIWUNG CISADANE",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
  },
  "smartwater.sda.pu.go.id": {
    mobile_logo: logo_cilicis,
    logo: logo_cilicis,
    logo_black: logo_cilicis,
    title: "Smart Water Center",
    short_title: "SWC Cilicis",
    sub_title: "BBWS Ciliwung Cisadane",
    background: background_cilicis,
    form_link: "https://cilicis.mapid.io/",
    status: "premium",
    is_domain_kai: false,
    show_survey_1: false,
    organization: "BBWS CILIWUNG CISADANE",
    continent: "Asia",
    industry: "Government",
    objective: "Create and Run Data Processing and Analytical Workflows",
    is_login_kai: false,
    is_hide_insight: true,
  },
  "pelindo.mapid.io": {
    mobile_logo: logo_pelindo,
    logo: logo_pelindo,
    logo_black: logo_pelindo,
    title: "PELINDO",
    short_title: "PELINDO",
    sub_title: "PELINDO",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "prod",
  },
  "pelindo-alpha.mapid.io": {
    mobile_logo: logo_pelindo,
    logo: logo_pelindo,
    logo_black: logo_pelindo,
    title: "PELINDO",
    short_title: "PELINDO",
    sub_title: "PELINDO",
    background: background_mapid,
    form_link: "https://form.mapid.io/",
    status: "premium",
    is_domain_kai: true,
    show_survey_1: true,
    tag_line_image: connected_future,
    is_login_kai: false,
    env: "alpha",
  },
};

export default domain_list;
